<template>
  <div id="app">
    <div id='container'>
      
      <!-- START ROW 1 -->
        <div class="row">
          <!-- LAB -->
          <div class="col">
            <div class="form-group">
              <b-form-group id="lab" label="Lab:" label-for="form-lab-input">
                  <ejs-dropdownlist
                          id="lab-dropdownlist"
                          :dataSource='labData' :fields="labFields" :v-model="loc.lab"
                          placeholder='Select a lab' @change='getFreezersOfSelectedLab'
                          :value="selectDropDownItemForUpdate('lab-dropdownlist', loc.lab, labData)"
                  ></ejs-dropdownlist>
              </b-form-group>
            </div>
        </div>

          <!-- FREEZER -->
          <div class="col">
          <div class="form-group">
            <b-form-group id="freezer" label="Freezer:" label-for="form-freezer-input">
              <ejs-dropdownlist
                        id='freezer-dropdownlist' ref='freezer'
                        :dataSource='freezerData' :fields='freezerFields'
                        :enabled='freezerEnabled' @change='setSelectedFreezer()'
                        :v-model="loc.freezer" placeholder='Select a freezer'
                        :value="selectDropDownItemForUpdate('freezer-dropdownlist', loc.freezer, freezerData)"
              ></ejs-dropdownlist>
            </b-form-group>
          </div>
        </div>
        </div>
      <!-- END ROW 1 -->

      <!-- START ROW 2 -->
      <div class="row">
        <!-- FREEZER-VIEW component -->
        <div class="col" v-if="loc.freezer !== ''">
          <freezer-view></freezer-view>
        </div>
      </div>
      <!-- END ROW 2 -->

    </div>
  </div>
</template>
<script>
import {
  extractLabData, extractFreezerData, getItemDataList, getSelectedItemCode, selectDropDownItemForUpdate
} from "@/utils/util_functions";
import {lab_resource} from "@/utils/api_paths";
import EventBus from "@/components/EventBus";
import FreezerView from "@/forms/view/FreezerView";

export default {
  components: {FreezerView},
  data () {
    return {
      loc: { lab: '', freezer: ''},

      // flag will be used to determine how data is displayed and selected on load
      is_reconstructing: false,

      // disabled fields
      freezerEnabled: false,

      // data lists
      labData: [],
      freezerData: [],

      // fields
      labFields: { value: '', text: '' },
      freezerFields: { value: '', text: '' },
    }
  },

  mounted() {
    EventBus.$on('locationFinder', () => {
      this.getLabList()
    })

    EventBus.$on('retrieve_sample_location_details', payload=> {
      this.is_reconstructing = true
      // lab details
      this.labData = payload['labData']
      this.labFields = payload['labFields']
      this.loc.lab = payload['labCode']
      
      // freezer details
      this.freezerEnabled = true
      this.freezerData = payload['freezerData']
      this.freezerFields = payload['freezerFields']
      this.loc.freezer = payload['freezerCode']
    })
  },

  methods: {
      selectDropDownItemForUpdate,
      // GET LAB LIST
      getLabList() {
        getItemDataList(lab_resource).then(data => {
          let labList = extractLabData(data);

          // update local variables with data from API
          this.labFields = labList['fields'];
          for (let i = 0; i < labList.items.length; i++) {
            this.labData.push({
              'Code': labList.items[i].Code,
              'Name': labList.items[i].Name,
            });
          }
        })
      },

      resetFields(){
        this.freezerData = []
        this.loc.freezer = ''
      },

      getFreezersOfSelectedLab() {
          if (!this.is_reconstructing){
            // set the lab selected
            this.loc.lab = getSelectedItemCode("lab-dropdownlist", this.labData)

            // enable freezer fields
            this.freezerEnabled = true

            // reset list on getting new list
            this.resetFields()

            getItemDataList(lab_resource, {
                'q': this.loc.lab
            }).then(data => {
              let freezerList = extractFreezerData(data);

              // update local variables with data from API
              this.freezerFields = freezerList['fields'];
              for (let i = 0; i < freezerList.items.length; i++) {
                this.freezerData.push({
                  'Code': freezerList.items[i].Code,
                  'Name': freezerList.items[i].Name,
                });
              }
            })
          }
      },

      setSelectedFreezer(){
        if (!this.is_reconstructing){
          this.loc.freezer = getSelectedItemCode("freezer-dropdownlist", this.freezerData)
          EventBus.$emit('freezerSet', this.loc.freezer)
          // Emit event to save details about the selected sample location
          EventBus.$emit('sample_location_details', {
            'labData': this.labData,
            'labFields':this.labFields,
            'labCode': this.loc.lab,

            'freezerData': this.freezerData,
            'freezerFields':this.freezerFields,
            'freezerCode': this.loc.freezer,
          })
          let is_creating = true
          EventBus.$emit('sample-creating', is_creating)
        }
      },
  },
}
</script>
